export const [FETCH_OPEN_PROPOSALS, UPDATE_SERVICE_TYPE] =
    ['FETCH_OPEN_PROPOSALS', 'UPDATE_SERVICE_TYPE']
